// @flow

import React from 'react';

export const DownloadIcon = prop => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="26"
    height={prop.height}
  >
    <rect
      id="backgroundrect"
      width="100%"
      height="100%"
      x="0"
      y="0"
      fill="none"
      stroke="none"
    />
    <g className="currentLayer" style={{}}>
      <title>Download</title>
      <g id="svg_1" className="">
        <g strokeWidth="0" id="svg_2">
          <g id="file-download" strokeWidth="0">
            <path
              d="M26.403612900000013,11.315834099999023 h-7.5438894 V-9.663381189396704e-13 h-11.3158341 v11.3158341 h-7.5438894 l13.201806450000001,13.201806450000001 L26.403612900000013,11.315834099999023 zM0,28.28958524999905 v3.7719447 h26.403612900000002 v-3.7719447 H0 z"
              data-original="#000000"
              className="active-path"
              data-old_color="#7f7f7f"
              fill={prop.color}
              strokeWidth="0"
              id="svg_3"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

type SelectedCheckedIconProps = {
  color: string
};

export const SelectedCheckedIcon = (props: SelectedCheckedIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
      fill={props.color}
    />
  </svg>
);

export const CheckListIcon = prop => (
  <svg
    width={prop.width || '208'}
    height={prop.height || '277'}
    viewBox="0 0 208 277"
  >
    <g fill="#000" fillRule="evenodd" opacity="0.2">
      <path d="M101.44 105.544c-3.413-3.38-8.96-3.398-12.391-.017l-28.809 28.55-11.306-11.216c-3.413-3.38-8.961-3.38-12.374 0a8.615 8.615 0 0 0 0 12.256l17.502 17.335A8.708 8.708 0 0 0 60.24 155c2.24 0 4.48-.85 6.196-2.53l35.004-34.67a8.615 8.615 0 0 0 0-12.256zM101.44 175.544c-3.413-3.38-8.96-3.398-12.391-.017l-28.809 28.55-11.306-11.198c-3.413-3.38-8.961-3.38-12.374 0a8.615 8.615 0 0 0 0 12.255l17.502 17.335A8.763 8.763 0 0 0 60.24 225c2.24 0 4.48-.85 6.196-2.53l35.004-34.67a8.615 8.615 0 0 0 0-12.256zM165.333 122h-34.666c-4.784 0-8.667 3.808-8.667 8.5s3.883 8.5 8.667 8.5h34.666c4.784 0 8.667-3.808 8.667-8.5s-3.883-8.5-8.667-8.5zM165.333 190h-34.666c-4.784 0-8.667 3.808-8.667 8.5s3.883 8.5 8.667 8.5h34.666c4.784 0 8.667-3.808 8.667-8.5s-3.883-8.5-8.667-8.5z" />
      <path
        fillRule="nonzero"
        d="M190.667 34.625H156v-8.656c0-4.779-3.883-8.657-8.667-8.657h-18.806C124.939 7.238 115.3 0 104 0S83.061 7.237 79.473 17.313H60.667c-4.784 0-8.667 3.878-8.667 8.656v8.656H17.333C7.783 34.625 0 42.398 0 51.938v207.75C0 269.226 7.783 277 17.333 277h173.334c9.55 0 17.333-7.773 17.333-17.313V51.938c0-9.539-7.783-17.312-17.333-17.312zm-121.334 0h17.334c4.784 0 8.666-3.878 8.666-8.656 0-4.779 3.883-8.657 8.667-8.657s8.667 3.878 8.667 8.657c0 4.778 3.882 8.656 8.666 8.656h17.334v17.313H69.333V34.624zm121.334 225.063H17.333V51.938H52v8.656c0 4.778 3.883 8.656 8.667 8.656h86.666c4.784 0 8.667-3.878 8.667-8.656v-8.657h34.667v207.75z"
      />
    </g>
  </svg>
);

export const SuccessCircleTickIcon = prop => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={prop.width || '20'}
    height={prop.height || '20'}
    viewBox="0 0 20 20"
  >
    <g fill="none" fillRule="evenodd">
      <path fill="#F2F2F2" d="M-760-477H520v750H-760z" />
      <g>
        <circle cx="10" cy="10" r="10" fill="#429946" />
        <path
          fill="#FFF"
          d="M7.771 15.2L3.2 10.593l1.29-1.299 3.281 3.299 6.94-6.993L16 6.908z"
        />
      </g>
    </g>
  </svg>
);

export const DocumentsListIcon = prop => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={prop.width || '24'}
    height={prop.height || '24'}
    viewBox="0 0 24 24"
  >
    <defs>
      <path id="a" d="M0 0h24v24H0V0z" />
    </defs>
    <clipPath id="b">
      <use xlinkHref="#a" overflow="visible" />
    </clipPath>
    <path
      fill="currentColor"
      clipPath="url(#b)"
      d="M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z"
    />
  </svg>
);

export const ClockIcon = prop => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={prop.width || '24'}
    height={prop.height || '24'}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    />
    <path d="M0 0h24v24H0z" fill="none" />
    <path fill="currentColor" d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
  </svg>
);

export const BaseLineErrorIcon = prop => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={prop.width || '24'}
    height={prop.height || '24'}
    viewBox="0 0 24 24"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
  </svg>
);

export const BaseLineHelpIcon = prop => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={prop.width || '18'}
    height={prop.height || '18'}
    viewBox="0 0 24 24"
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" />
  </svg>
);
export const DownloadNewIcon = prop => (
  <svg
    height="50px"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 50 50"
    width={prop.width || '50px'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="none" height="50" width="50" />
    <path
      d="  M32,35c0,0,8.312,0,9.098,0C45.463,35,49,31.463,49,27.099s-3.537-7.902-7.902-7.902c-0.02,0-0.038,0.003-0.058,0.003  c0.061-0.494,0.103-0.994,0.103-1.504c0-6.71-5.439-12.15-12.15-12.15c-5.229,0-9.672,3.309-11.386,7.941  c-1.087-1.089-2.591-1.764-4.251-1.764c-3.319,0-6.009,2.69-6.009,6.008c0,0.085,0.01,0.167,0.013,0.251  C3.695,18.995,1,22.344,1,26.331C1,31.119,4.881,35,9.67,35c0.827,0,8.33,0,8.33,0"
      fill="none"
      stroke="#000000"
    />
    <polyline fill="none" points="30,41 25,46 20,41   " stroke="#000000" />
    <line fill="none" stroke="#000000" x1="25" x2="25" y1="26" y2="45.668" />
  </svg>
);
